module.exports = __webpack_public_path__ + "static/media/mycart_product6.041179d7.png";